import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import * as Rusha from 'rusha';
export var SimpleHasher = /*#__PURE__*/function () {
  function SimpleHasher() {
    _classCallCheck(this, SimpleHasher);
  }
  return _createClass(SimpleHasher, [{
    key: "hash",
    value: function hash(blob) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsArrayBuffer(blob);
        reader.onload = function () {
          var _reader$result;
          resolve(Rusha.createHash().update((_reader$result = reader.result) !== null && _reader$result !== void 0 ? _reader$result : '').digest('hex'));
        };
        reader.onerror = reject;
      });
    }
  }]);
}();